const NewRelicConfiguration = (environment = 'dev-app.myjobnow.com') => {
  if (environment === 'dev-app.myjobnow.com' || environment === 'localhost') {
    return {
      // NREUM.init
      init: {
        session_replay: {
          enabled: true,
          block_selector: '',
          mask_text_selector: '*',
          sampling_rate: 10.0,
          error_sampling_rate: 100.0,
          mask_all_inputs: true,
          collect_fonts: true,
          inline_images: false,
          inline_stylesheet: true,
          fix_stylesheets: true,
          preload: true,
          mask_input_options: {},
        },
        distributed_tracing: { enabled: true },
        privacy: { cookies_enabled: true },
        ajax: { deny_list: ['bam.eu01.nr-data.net'] },
      },
      // NREUM.info
      info: {
        beacon: 'bam.eu01.nr-data.net',
        errorBeacon: 'bam.eu01.nr-data.net',
        licenseKey: 'NRJS-317e383610bf84150ea',
        applicationID: '538715072',
        sa: 1,
      },
      // NREUM.loader_config
      loader_config: {
        accountID: '3049442',
        trustKey: '3049442',
        agentID: '538715072',
        licenseKey: 'NRJS-317e383610bf84150ea',
        applicationID: '538715072',
      },
    };
  }

  // PRODUCTION CONFIGURATION
  return {
    // NREUM.init
    init: {
      privacy: { cookies_enabled: true },
      ajax: { deny_list: ['bam.eu01.nr-data.net'] },
    },
    // NREUM.info
    info: {
      beacon: 'bam.eu01.nr-data.net',
      errorBeacon: 'bam.eu01.nr-data.net',
      licenseKey: 'NRJS-317e383610bf84150ea',
      applicationID: '538715076',
      sa: 1,
    },
    // NREUM.loader_config
    loader_config: {
      accountID: '3049442',
      trustKey: '3049442',
      agentID: '538715076',
      licenseKey: 'NRJS-317e383610bf84150ea',
      applicationID: '538715076',
    },
  };
};
export default NewRelicConfiguration;
